





























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { MotivoCancelamento } from '@/models'
import { SaveMotivosDeCancelamentoUseCase } from '@/usecases'

@Component

export default class DialogoDeEdicaoDeMotivosDeCancelamentoFiscal extends Vue {
	@Prop({type: Object}) motivo?: MotivoCancelamento
	motivoEmEdicao: string | undefined
	mostra = false
	salvando = false
	saveMotivoDeCancelamentoFiscalUseCase = new SaveMotivosDeCancelamentoUseCase()

	mostrar() {
		this.onChangeMotivo()
		this.mostra = true
	}

	esconder() {
		this.motivoEmEdicao = undefined
		
		this.mostra = false
	}

	async salvar() {
		if (!this.motivo) return
		if (!this.motivoEmEdicao) return

		try {
			this.salvando = true

			this.editarMotivo()

			this.motivo.isFiscal = true

			const motivoSalvo = this.motivo.id
				? await this.saveMotivoDeCancelamentoFiscalUseCase.update(this.motivo)
				: await this.saveMotivoDeCancelamentoFiscalUseCase.create(this.motivo)

			if(this.motivo.motivo.length < 15){
				AlertModule.setError("É necessario que o motivo tenha ao menos 15 caracteres.")
				return
			}

			this.motivo.id
				? this.$emit('update', motivoSalvo)
				: this.$emit('create', motivoSalvo)
			this.mostra = false
			AlertModule.setSuccess('Motivo salvo com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	editarMotivo() {
		if(this.motivo && this.motivoEmEdicao) this.motivo.motivo = this.motivoEmEdicao
	}

	@Watch('motivo')
	onChangeMotivo() {
		if(this.motivo){
			this.motivoEmEdicao = this.motivo.motivo
		}
	}

}
